import React, { useState, useEffect, useCallback } from 'react';
import useAllWorkshops from 'hooks/useAllWorkshops';
import Popover from 'components/Core/Popover';
import { Col, Row } from 'components/Core/Grid';
import Tag from 'components/Core/Tag';
import { STIcon } from 'components/Brand/Icons/STIcon';
import { SearchInput } from 'components/Core/TextField/SearchInput';
import useBreakpointView from 'utils/useBreakpointView';
import Workshop from './Workshop';
import { FilterRow } from './styles';

const WorkshopList = ({}) => {
  const workshops = useAllWorkshops();
  const categoryList = [...new Set(workshops.flatMap((x) => x.categories))];
  const [gridMode, setGridMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState();
  const [selectedTags, setSelectedTags] = useState([]);
  const isMobile = useBreakpointView(['xs', 'sm']);
  const [mobileSearchVisible, setMobileSearchVisible] = useState(false);
  const [filtered, setFiltered] = useState(workshops);

  const filterSearch = (term = searchTerm, tags = selectedTags) => {
    let tempFiltered =
      tags.length > 0
        ? workshops.filter((workshop) => workshop?.categories?.some((x) => tags.includes(x)))
        : workshops;

    if (term) {
      tempFiltered = tempFiltered.filter(
        (workshop) =>
          workshop?.title?.toLowerCase().includes(term?.toLowerCase()) ||
          workshop?.excerpt?.excerpt?.toLowerCase().includes(term?.toLowerCase()),
      );
    }

    setFiltered(tempFiltered);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const SearchMenu = () => (
    <div className="search-menu-popup">
      <SearchInput handleSearch={handleSearch} allowClear value={searchTerm} autoFocus />
    </div>
  );

  const showSearch = (e) => {
    setMobileSearchVisible(true);

    document.addEventListener('mouseup', function (e) {
      const container = document.getElementsByClassName('search-menu-popup')[0];
      if (container && !container.contains(e.target)) {
        setMobileSearchVisible(false);
      }
    });
  };

  const tagClick = (tag, setTags = setSelectedTags, tags = selectedTags) => {
    if (!tags.includes(tag)) {
      setTags([...tags, tag]);
      return [...tags, tag];
    } else {
      setTags([...tags.filter((t) => t !== tag)]);
      return [...tags.filter((t) => t !== tag)];
    }
  };

  useEffect(() => {
    filterSearch();
  }, [selectedTags, searchTerm]);

  return (
    <>
      <FilterRow>
        <Col md={20} xs={24} sx={{ display: 'flex' }}>
          <Popover
            content={<SearchMenu />}
            placement="bottom-start"
            PaperProps={{ style: { marginTop: '10px' } }}
            {...(isMobile ? { visible: false } : {})}
          >
            <STIcon
              type="icon-search"
              onClick={showSearch}
              data-testid="search-icon-button"
              className={`search-icon-container${searchTerm ? ' selected' : ''}`}
            />
          </Popover>
          {categoryList.map((category) => (
            <Tag
              className={selectedTags.includes(category) ? 'selected' : ''}
              onClick={() => tagClick(category)}
            >
              {category}
            </Tag>
          ))}
        </Col>
        <Col md={4} xs={0} style={{ textAlign: 'right' }} className="search-icons">
          <STIcon
            type="icon-appstore"
            onClick={() => setGridMode(true)}
            className={gridMode ? ' selected' : ''}
          />

          <STIcon
            type="icon-bars"
            onClick={() => setGridMode(false)}
            className={!gridMode ? 'selected' : ''}
          />
        </Col>
        {mobileSearchVisible && isMobile && <SearchMenu />}
      </FilterRow>
      <Row gutter={40}>
        {filtered?.map((workshop) => (
          <Workshop {...workshop} gridMode={gridMode && !isMobile} />
        ))}
      </Row>
    </>
  );
};

export default WorkshopList;
